module.exports = __webpack_public_path__ + "img/close_icon.6f5537fd.svg";